
import { Options } from 'vue-class-component'
import { Mixins, Prop } from 'vue-property-decorator'
import { CardResultMixin } from '../card-result/cardresultmixin'
import { RESULT } from '@/utils/constants'

@Options({
    name: 'good-road-card-result'
})
export default class GoodRoadCardResult extends Mixins(CardResultMixin) {
    @Prop({ default: false }) isDesktop!: boolean
    @Prop({ default: 'G002' }) gameTypeNo!: string

    get isDragonTiger(): boolean {
        return this.gameTypeNo !== 'G002'
    }

    get isBlueSideWin(): boolean {
        return (
            this.winner === RESULT.BLUE || this.winner === RESULT.TIGER
        )
    }

    get isRedSideWin(): boolean {
        return (
            this.winner === RESULT.RED ||
            this.winner === RESULT.DRAGON ||
            this.winner === RESULT.SUPER6
        )
    }
}
